export default __webpack_public_path__ + "3a469d2714f592b5467a4cdd388bee8a.svg";